import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Fade,
    Slide,
    Typography
} from "@mui/material";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import React from "react";

const Transition = React.forwardRef(function Transition(props, ref) {
  return (
    <Fade in timeout={200}>
      <Slide direction="down" ref={ref} {...props} />
    </Fade>
  );
});

export default function CartoonDialog({
  open,
  onClose,
  title,
  description,
  onAccept,
  onCancel,
  acceptLabel = "Accept",
  cancelLabel = "Cancel",
  showActions = true,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      keepMounted
      PaperProps={{
        sx: {
          borderRadius: 8,
          border: "3px solid black",
          backgroundColor: "#fffde7",
          boxShadow: "8px 8px 0px rgba(0,0,0,0.3)",
          px: 3,
          py: 2,
          maxWidth: 750,
        },
      }}
    >
      <DialogTitle>
        <MKTypography
          variant="h4"
          sx={{
            fontWeight: "bold",
            color: "black !important",
            textShadow: "2px 2px 0px white",
          }}
        >
          {title}
        </MKTypography>
      </DialogTitle>

      <DialogContent>
        <MKTypography variant="body1" sx={{ color: "black", fontSize: "1rem", mt: 1 }}>
          {description}
        </MKTypography>
      </DialogContent>

      {showActions && (
        <DialogActions sx={{ justifyContent: "flex-end", gap: 1, mt: 2 }}>
          {onCancel && (
            <MKButton
              variant="outlined"
              onClick={onCancel}
              cartoonish
              sx={{
                color: "black !important",
              }}
            >
              {cancelLabel}
            </MKButton>
          )}
          {onAccept && (
            <MKButton
              variant="contained"
              onClick={onAccept}
              cartoonish
              sx={{
                backgroundColor: "#8bc34a",
                color: "black !important",
              }}
            >
              {acceptLabel}
            </MKButton>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
}
